import { RedirectSourceEnum } from '../redirect-source-enum';

export const environment = {
  production: true,
  environment: 'production',

  // the Application id for this specific app
  authAppId: 'viFfehy9IylkTLbMyrd1SOUDclamOWr6OZb5XPudWdE',

  // the successful login return url
  authRedirectURI: 'https://support.reconcept.nl/login/success/',

  // the RedirectSource corresponding with backend
  authRedirectSource: RedirectSourceEnum.PORTFOLIO,

  // the requested grant scope
  authScope: 'user support',

  // the authenticator title for this specific environment and app
  otpIssuer: 'Reconcept Support',

  applicationName: 'Support',
};
